import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import api, { formatApiErrorDetail } from "@/lib/api";

const FIELDS = [
  ["company_name", "Company name"],
  ["tagline", "Tagline"],
  ["phone", "Phone number"],
  ["whatsapp", "WhatsApp number"],
  ["email", "Contact email"],
  ["domain", "Website domain"],
  ["address", "Address"],
  ["facebook_url", "Facebook URL"],
  ["instagram_url", "Instagram URL"],
  ["hero_headline", "Homepage headline"],
];

export const SettingsManager = () => {
  const [form, setForm] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get("/settings").then((res) => setForm(res.data)).catch(() => {});
  }, []);

  const save = async () => {
    setSaving(true);
    try {
      await api.put("/admin/settings", form);
      toast.success("Settings saved — the website is updated.");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    } finally { setSaving(false); }
  };

  if (!form) return <p className="text-slate-500 text-sm">Loading settings...</p>;

  return (
    <div className="max-w-2xl" data-testid="settings-manager">
      <h2 className="text-2xl font-semibold text-slate-900 mb-5">Site settings</h2>
      <div className="bg-white border border-slate-200 rounded-lg p-6 sm:p-8 space-y-5">
        <div className="grid sm:grid-cols-2 gap-5">
          {FIELDS.map(([key, label]) => (
            <div key={key} className={`space-y-2 ${key === "hero_headline" ? "sm:col-span-2" : ""}`}>
              <Label htmlFor={`setting-${key}`}>{label}</Label>
              <Input id={`setting-${key}`} data-testid={`setting-${key}`} value={form[key] || ""}
                onChange={(e) => setForm({ ...form, [key]: e.target.value })} />
            </div>
          ))}
          <div className="space-y-2 sm:col-span-2">
            <Label htmlFor="setting-hero_subtext">Homepage intro text</Label>
            <Textarea id="setting-hero_subtext" data-testid="setting-hero_subtext" rows={3}
              value={form.hero_subtext || ""} onChange={(e) => setForm({ ...form, hero_subtext: e.target.value })} />
          </div>
        </div>
        <Button onClick={save} disabled={saving} data-testid="settings-save-btn"
          className="bg-blue-600 hover:bg-blue-700 text-white">
          {saving ? "Saving..." : "Save settings"}
        </Button>
      </div>
    </div>
  );
};
